"use client";

import { Link } from 'react-router-dom';
import GalleryImg1 from '../../assets/images/gallery/gallery-apparel.png';
import GalleryImg2 from '../../assets/images/gallery/gallery-drinkware.png';
import GalleryImg3 from '../../assets/images/gallery/gallery-office.png';
import GalleryImg4 from '../../assets/images/gallery/gallery-tech.png';
import GalleryImg5 from '../../assets/images/gallery/gallery-event.png';
import GalleryImg6 from '../../assets/images/gallery/gallery-sports.png';
import GalleryImg7 from '../../assets/images/gallery/gallery-corporate.png';
import GalleryImg9 from '../../assets/images/gallery/gallery-business.png';

const galleryItems = [
  {
    src: GalleryImg1,
    alt: "Custom Apparel",
    title: "Custom Branded Apparel",
    subtitle: "T-Shirts & Polos",
    href: "/services",
  },
  {
    src: GalleryImg2,
    alt: "Corporate Drinkware",
    title: "Premium Drinkware",
    subtitle: "Mugs & Tumblers",
    href: "/services",
  },
  {
    src: GalleryImg3,
    alt: "Office Supplies",
    title: "Office & Stationery",
    subtitle: "Pens & Notebooks",
    href: "/services",
  },
  {
    src: GalleryImg4,
    alt: "Tech Accessories",
    title: "Technology Products",
    subtitle: "USB & Chargers",
    href: "/services",
  },
  {
    src: GalleryImg5,
    alt: "Trade Show Materials",
    title: "Event & Trade Show",
    subtitle: "Banners & Displays",
    href: "/services",
  },
  {
    src: GalleryImg6,
    alt: "Sports Equipment",
    title: "Sports & Recreation",
    subtitle: "Team Gear & Equipment",
    href: "/services",
  },
  {
    src: GalleryImg7,
    alt: "Corporate Gifts",
    title: "Corporate Gift Sets",
    subtitle: "Executive & Client Gifts",
    href: "/services",
  },
  {
    src: GalleryImg9,
    alt: "Unique Custom Items",
    title: "Unique Custom Products",
    subtitle: "Special Orders",
    href: "/services",
  },
];

export default function GalleryOne() {
  

  return (
    <section className="gallery-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Products</span>
          </div>
          <h2 className="section-title__title">
            See What We Can Do for You
          </h2>
        </div>
        <div className="row masonary-layout">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className={`col-xl-${index === 8 ? 3 : 3} col-lg-6 col-md-6`}
            >
              <div className="gallery-one__single">
                <div className="gallery-one__img">
                  <img src={item.src} alt={item.alt} />
                  <div className="gallery-one__content">
                    <div className="gallery-one__sub-title-box">
                      <div className="gallery-one__sub-title-shape"></div>
                      <p className="gallery-one__sub-title">{item.subtitle}</p>
                    </div>
                    <h4 className="gallery-one__title">
                      <Link to={item.href}>{item.title}</Link>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-4">
          <p className="gallery-one__note">Contact us to see samples of products in your industry</p>
        </div>
      </div>
    </section>
  );
}
